import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchActionLog, fetchActionLogByFilter } from '../../actions/settings_actions';
import ActionLog from '../../components/Settings/ActionLog';

const actionLog = reduxForm({
  form: 'actionLog',
  destroyOnUnmount: false,
})(ActionLog);

const selector = formValueSelector('actionLog');

function mapStateToProps(state) {
  const field = selector(state, 'Field');
  return {
    field,
    actionLog: state.settings.actionLog,
    actionLogIsLoading: state.settings.actionLogIsLoading,
    actionLogError: state.settings.actionLogError,
    userPermissions: state.auth.userPermissions,
  };
}

export default connect(mapStateToProps, { fetchActionLog, fetchActionLogByFilter })(actionLog);



// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/ActionLog.jsx